import { QUOTE_STATUSES, QUOTE_STATUS_META, normalizeStatus } from "@/lib/quotationApi";

// Read-only colored pill for a quotation status.
export const StatusBadge = ({ status, testId, className = "" }) => {
  const meta = QUOTE_STATUS_META[normalizeStatus(status)];
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[10px] font-semibold uppercase tracking-wider border ${className}`}
      style={{ color: meta.color, background: meta.bg, borderColor: meta.border }}
    >
      <span className="w-1.5 h-1.5 rounded-full" style={{ background: meta.color }} />
      {meta.label}
    </span>
  );
};

// Editable status pill (native select styled as a pill). onChange(newStatus).
export const StatusSelect = ({ status, onChange, testId, disabled, canApprove = true }) => {
  const cur = normalizeStatus(status);
  const meta = QUOTE_STATUS_META[cur];
  // Hide "approved" unless the member can approve — but always keep the
  // current value visible so an already-approved quote renders correctly.
  const options = QUOTE_STATUSES.filter(
    (s) => s !== "approved" || canApprove || s === cur
  );
  return (
    <select
      value={cur}
      disabled={disabled}
      data-testid={testId}
      onClick={(e) => e.stopPropagation()}
      onChange={(e) => {
        e.stopPropagation();
        onChange(e.target.value);
      }}
      className="appearance-none cursor-pointer rounded-full pl-3 pr-6 py-1 text-[10px] font-semibold uppercase tracking-wider border outline-none disabled:opacity-50 bg-no-repeat"
      style={{
        color: meta.color,
        backgroundColor: meta.bg,
        borderColor: meta.border,
        backgroundImage:
          "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='10' viewBox='0 0 24 24' fill='none' stroke='%23888' stroke-width='3'><path d='M6 9l6 6 6-6'/></svg>\")",
        backgroundPosition: "right 8px center",
      }}
    >
      {options.map((s) => (
        <option key={s} value={s} style={{ color: "#111", background: "#fff" }}>
          {QUOTE_STATUS_META[s].label}
        </option>
      ))}
    </select>
  );
};
